/**
 * BC Quiz Insentials — Shopify Liquid Quiz Engine
 * State machine: landing → welcome → email → Q1 → Q2[path] → Q3[path] → loading → results
 * Content from schema/blocks JSON, routing logic hardcoded below.
 */
(function () {
  'use strict';

  // ── Quiz routing map ──────────────────────────────────────────────────────────
  // Defines which Q2/Q3 question_id to show based on Q1 answer value (= path key)
  // Q1 answer values are the profile keys in lowercase
  const ROUTING = {
    weight:   { path: 'WEIGHT',   q2: 'q2_weight',   q3: 'q3_weight'   },
    liver:    { path: 'LIVER',    q2: 'q2_liver',    q3: 'q3_liver'    },
    hormones: { path: 'HORMONES', q2: 'q2_hormones', q3: 'q3_hormones' },
    beauty:   { path: 'BEAUTY',   q2: 'q2_beauty',   q3: 'q3_beauty'   },
    energy:   { path: 'ENERGY',   q2: 'q2_energy',   q3: 'q3_energy'   },
    daily:    { path: 'DAILY',    q2: 'q2_daily',    q3: 'q3_daily'    },
  };

  // ── Profile key mapping (Liquid path → React letter) ─────────────────────────
  const PROFILE_MAP = {
    WEIGHT: 'M', LIVER: 'F', HORMONES: 'T', BEAUTY: 'B', ENERGY: 'E', DAILY: 'P'
  };

  // ── Hardcoded data constants (mirroring React ResultsPage.tsx) ────────────────
  const CDN = 'https://insentials.com/cdn/shop/files/';

  // Icônes décoratives. Tous les textes associés sont administrables :
  // cartes d'analyse, ingrédients et avis dans les blocs de profil,
  // accroches et bénéfices produit dans les settings de la section.
  const CARD_ICONS = [
    CDN + 'light_rise.png',
    CDN + 'less_sugar_spikes_7b54e9d5-e45d-4e7e-81fd-fcc92595fa25.png',
    CDN + 'weight_control_810f6aa8-a1f5-4c9d-bf21-b3343e9b6736.png'
  ];
  const BENEFIT_ICONS = [
    CDN + 'less_sugar_spikes_7b54e9d5-e45d-4e7e-81fd-fcc92595fa25.png',
    CDN + 'weight_control_810f6aa8-a1f5-4c9d-bf21-b3343e9b6736.png'
  ];

  // Splits a Shopify product title into name + trademarked/technical subtitle
  // for products whose title bakes both together (mirrors ProductRec.subtitle in React profiles.ts)
  const PRODUCT_NAME_SPLIT = {
    'GLH-2 Glucoreductase™': { name: 'GLH-2', subtitle: 'GLUCOREDUCTASE™' },
    'Inner Beauty H5-NADH™': { name: 'Inner Beauty', subtitle: 'H5-NADH™' }
  };
  function splitProductName(title) {
    return PRODUCT_NAME_SPLIT[title] || { name: title, subtitle: null };
  }

  var _sel = { selected: null, aboMode: null };

  // ── State ──────────────────────────────────────────────────────────────────────
  const state = {
    path: null,         // 'WEIGHT' | 'LIVER' | etc.
    q1Answer: null,
    q2Answer: null,
    q3Answer: null,
    q1Value: null,      // valeurs brutes (pas les libellés) : reco + suivi Klaviyo
    q2Value: null,
    q3Value: null,
    skipQ3: false,
    direction: 1,       // 1 = forward, -1 = back (for slide transitions)
    currentStep: 0,     // 0=landing,1=q1,2=q2,3=q3,4=email,5=loading,6=results
    questionSequence: [], // ordered question_ids for this run
    data: null,
  };

  // ── DOM refs ──────────────────────────────────────────────────────────────────
  const root = document.getElementById('bc-quiz-insentials');
  if (!root) return;

  const sectionId  = root.dataset.sectionId;
  const dataScript = document.getElementById('bc-quiz-data-' + sectionId);
  if (!dataScript) return;

  try {
    state.data = JSON.parse(dataScript.textContent);
  } catch (e) {
    console.error('[BCQuiz] Failed to parse quiz data', e);
    return;
  }

  const s   = state.data.settings;
  const qs  = document.querySelectorAll.bind(root);
  const q   = document.querySelector.bind(root);

  // ── Screens ───────────────────────────────────────────────────────────────────
  const SCREENS = {
    welcome:  document.getElementById('bc-screen-welcome'),
    email:    document.getElementById('bc-screen-email'),
    question: document.getElementById('bc-screen-question'),
    loading:  document.getElementById('bc-screen-loading'),
    results:  document.getElementById('bc-screen-results'),
  };

  // Le header du thème est un frère de <main> avec son propre contexte
  // d'empilement : aucun z-index posé depuis l'intérieur de la section ne peut
  // passer au-dessus. On le neutralise le temps que le quiz est ouvert.
  function setOverlayOpen(isOpen) {
    document.body.classList.toggle('bc-quiz-open', !!isOpen);
  }

  function showScreen(name) {
    // Welcome/landing always stays visible — only toggle overlay screens
    Object.entries(SCREENS).forEach(([key, el]) => {
      if (el && key !== 'welcome') el.classList.remove('bc-active');
    });
    if (name !== 'welcome' && SCREENS[name]) {
      SCREENS[name].classList.add('bc-active');
    }
    setOverlayOpen(name !== 'welcome');
  }

  // ── BC Tracker (funnel quiz → bc_tracker.quiz_events) ──────────────────────────
  // Envoie le funnel du quiz au tracker, rattaché au bc_sid / _bc_vid du bc-tracker
  // de la page (donc stitché aux sessions et aux achats). Fire-and-forget : une
  // erreur réseau ne casse jamais le quiz. Si le bc_sid n'est pas là, on n'envoie
  // rien (pas d'orphelin non rattaché).
  var BCQ_URL = 'https://os-cro.vercel.app/api/bc/quiz';
  var _bcqViewSent = false;
  function bcqCookie(n) { try { var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return ''; } }
  function bcqSite() { try { return (window.Shopify && window.Shopify.shop) || location.hostname; } catch (e) { return location.hostname; } }
  // Le cookie bc_sid du bc-tracker contient un OBJET JSON {sid,uid,...}, pas une
  // valeur brute → on parse pour récupérer le vrai sid (stitching sessions/achats).
  // Repli sur un sid propre persistant si le cookie n'est pas lisible, pour ne
  // jamais perdre le funnel.
  function bcqSession() {
    try {
      var raw = bcqCookie('bc_sid');
      if (raw) { var o = JSON.parse(raw); if (o && o.sid) return { sid: o.sid, uid: o.uid || '' }; }
    } catch (e) {}
    var fb = '';
    try {
      fb = localStorage.getItem('_bcq_sid') || '';
      if (!fb) { fb = 'q' + Math.random().toString(36).slice(2, 12) + Date.now().toString(36); localStorage.setItem('_bcq_sid', fb); }
    } catch (e) { fb = 'q' + Date.now().toString(36); }
    return { sid: fb, uid: '' };
  }
  function bcq(eventType, data, session) {
    try {
      var ses = bcqSession(), sid = ses.sid, vid = '';
      try { vid = localStorage.getItem('_bc_vid') || ses.uid || ''; } catch (e) { vid = ses.uid || ''; }
      if (!sid) return;
      var body = { sid: sid, vid: vid, site: bcqSite(), quiz_slug: 'insentials-quiz', event_type: eventType, data: data || {}, url: location.href };
      if (session) body.session = session;
      var blob = new Blob([JSON.stringify(body)], { type: 'application/json' });
      if (navigator.sendBeacon) { navigator.sendBeacon(BCQ_URL, blob); }
      else { fetch(BCQ_URL, { method: 'POST', body: blob, keepalive: true }).catch(function () {}); }
    } catch (e) {}
  }
  function bcqView() {
    if (_bcqViewSent) return;
    _bcqViewSent = true;
    var w = window.innerWidth;
    var device = w < 768 ? 'mobile' : (w < 1024 ? 'tablet' : 'desktop');
    var q = new URLSearchParams(location.search);
    bcq('view', { variant: s.klaviyo_event_name || '' }, {
      device: device, viewport: w + 'x' + window.innerHeight, referrer: document.referrer || '',
      utm_source: q.get('utm_source') || '', utm_medium: q.get('utm_medium') || '',
      utm_campaign: q.get('utm_campaign') || '', utm_content: q.get('utm_content') || ''
    });
  }

  // ── Data binding ─────────────────────────────────────────────────────────────
  function bindSettings() {
    root.querySelectorAll('[data-bind]').forEach(el => {
      const key = el.dataset.bind;
      if (s[key] !== undefined && s[key] !== null) {
        el.innerHTML = s[key];
      }
    });
    root.querySelectorAll('[data-bind-placeholder]').forEach(el => {
      const key = el.dataset.bindPlaceholder;
      if (s[key]) el.setAttribute('placeholder', s[key]);
    });
    root.querySelectorAll('[data-bind-href]').forEach(el => {
      const key = el.dataset.bindHref;
      if (s[key]) el.setAttribute('href', s[key]);
    });
    // Modal question logo
    const qLogo     = document.getElementById('bc-q-logo');
    const qLogoText = document.getElementById('bc-q-logo-text');
    if (s.logo_url) {
      if (qLogo)     { qLogo.src = s.logo_url; qLogo.style.display = 'block'; }
      if (qLogoText) qLogoText.style.display = 'none';
    } else {
      if (qLogo)     qLogo.style.display = 'none';
      if (qLogoText) qLogoText.style.display = '';
    }
    // Email modal logo — use white version if available
    const eLogo     = document.getElementById('bc-e-logo');
    const eLogoText = document.getElementById('bc-e-logo-text');
    const eLogoUrl  = s.logo_url_white || s.logo_url;
    if (eLogoUrl) {
      if (eLogo)     { eLogo.src = eLogoUrl; eLogo.style.display = 'block'; }
      if (eLogoText) eLogoText.style.display = 'none';
    } else {
      if (eLogo)     eLogo.style.display = 'none';
      if (eLogoText) eLogoText.style.display = '';
    }
    // Email banner background
    const emailBanner = document.getElementById('bc-email-banner');
    if (emailBanner && s.email_banner_url) {
      emailBanner.style.backgroundImage = 'url(' + s.email_banner_url + ')';
    } else if (emailBanner) {
      emailBanner.style.display = 'none';
    }
  }

  // ── Question helpers ─────────────────────────────────────────────────────────
  function getQuestion(id) {
    return state.data.questions.find(q => q.id === id);
  }

  // ── Profil + recommandation ──────────────────────────────────────────────────
  // Le narratif (titre, explication, badge, témoignage, timeline) vient du bloc
  // de parcours. Les produits viennent de la matrice, qui a une entrée par
  // combinaison Q2/Q3 et n'est administrable que depuis les settings de section.
  function comboKey() {
    if (!state.path || !state.q2Value) return null;
    return state.q3Value
      ? state.path + '_' + state.q2Value + '_' + state.q3Value
      : state.path + '_' + state.q2Value;
  }

  function resolveProduct(handle, variantId) {
    var catalog = (state.data && state.data.catalog) || {};
    var prod = handle && catalog[handle];
    if (!prod) return null;
    if (!variantId) return prod;
    var variant = (prod.variants || []).find(function (v) { return String(v.id) === String(variantId); });
    if (!variant) return prod;
    // Format forcé (ex. REE Shot x30 plutôt que x15) : on écrase prix et variante
    return Object.assign({}, prod, {
      variant_id: variant.id,
      price: variant.price,
      price_raw: variant.price_raw,
      available: variant.available,
    });
  }

  function resolveRec() {
    var empty = { hero_product: null, alt_products: [], alt_product: null, pack_product: null };
    var key = comboKey();
    var rec = key && state.data && state.data.recs && state.data.recs[key];
    if (!rec) {
      if (key) console.warn('[BCQuiz] Aucune reco configurée pour:', key);
      return empty;
    }
    var alts = (rec.alts || []).map(function (h) { return resolveProduct(h); }).filter(Boolean);
    return {
      hero_product: resolveProduct(rec.hero, rec.heroVariant),
      alt_products: alts,
      alt_product: alts[0] || null,   // conservé pour compatibilité
      pack_product: resolveProduct(rec.pack),
    };
  }

  function getProfile(key) {
    var base = state.data.profiles.find(p => p.key === key);
    if (!base) return base;
    return Object.assign({}, base, resolveRec());
  }

  // Accroche et bénéfices rattachés au produit : définis une seule fois dans les
  // settings, donc valables dans toutes les combinaisons qui poussent ce produit.
  function productText(handle) {
    var pt = ((state.data && state.data.productTexts) || {})[handle];
    return {
      tagline: (pt && pt.tagline) || '',
      benefits: (pt && pt.benefits) || [],
    };
  }

  // Note produit : vraie note reviews.io (métafield « reviews.rating » du
  // produit) si celui-ci a des avis, sinon repli sur la réassurance globale
  // (score fixe + « results_verified_count »). Sert à l'affichage ET au push.
  function productRating(prod) {
    var rt = prod && prod.rating;
    if (rt && typeof rt === 'object') rt = rt.rating || rt.value || '';  // robustesse métafield
    var rn = parseFloat(rt);                    // note numérique
    var rc = Number(prod && prod.rating_count) || 0;
    var real = !isNaN(rn) && rc > 0;
    var score = real ? rn.toFixed(2) : '';      // 2 décimales (ex. 4.62)
    var word = s.reviews_count_label || '';
    return {
      real: real,
      value: score,
      count: real ? rc : 0,
      score_display: real ? (score + '/5') : '4.6/5',
      count_display: real ? ('(' + rc + ' ' + word + ')') : (s.results_verified_count || ''),
    };
  }

  // Le produit principal accepte une accroche sur mesure par combinaison,
  // qui prend le pas sur l'accroche habituelle du produit.
  function heroTagline(prod) {
    var key = comboKey();
    var rec = key && state.data.recs && state.data.recs[key];
    if (rec && rec.tagline) return rec.tagline;
    return productText(prod.handle).tagline;
  }

  // Résout le produit derrière une carte ('hero', 'alt-0', 'alt-1', 'pack')
  function productForCard(profile, cardId) {
    if (!profile) return null;
    if (cardId === 'hero') return profile.hero_product;
    if (cardId === 'pack') return profile.pack_product;
    var m = /^alt-(\d+)$/.exec(cardId);
    if (m) return (profile.alt_products || [])[Number(m[1])] || null;
    return null;
  }

  // ── Render question ───────────────────────────────────────────────────────────
  function renderQuestion(questionId, stepNum, totalSteps) {
    const qData = getQuestion(questionId);
    if (!qData) {
      console.warn('[BCQuiz] Question not found:', questionId);
      return;
    }

    // GA4 : entrée dans le tunnel (une fois) puis chaque étape atteinte
    if (!state._ga4Started) { state._ga4Started = true; ga4('quiz_start', { langue: quizLocale() }); }
    ga4('quiz_question', { etape: stepNum, parcours: state.path || '', langue: quizLocale() });

    // 3-segment progress + legacy bar fallback
    for (let i = 1; i <= 3; i++) {
      const seg = document.getElementById('bc-seg-' + i);
      if (seg) seg.classList.toggle('bc-filled', i <= stepNum);
    }
    const bar = document.getElementById('bc-progress-bar');
    const cnt = document.getElementById('bc-progress-count');
    if (bar) bar.style.width = Math.round((stepNum / totalSteps) * 100) + '%';
    // Libellé éditable : {n} = question en cours, {total} = nombre total
    if (cnt) cnt.textContent = String(s.question_counter_label || '')
      .replace('{n}', stepNum).replace('{total}', totalSteps);

    // Eyebrow + question text
    const eyebrow = document.getElementById('bc-q-eyebrow');
    const qText   = document.getElementById('bc-q-text');
    if (eyebrow) eyebrow.textContent = qData.eyebrow || '';
    if (qText)   qText.textContent   = qData.question || '';

    // Answers
    const answersEl = document.getElementById('bc-q-answers');
    if (!answersEl) return;
    answersEl.innerHTML = '';

    const LETTERS = 'ABCDEF';
    qData.answers.forEach((ans, idx) => {
      if (!ans.label) return;
      const btn = document.createElement('button');
      btn.className = 'bc-quiz__answer';
      btn.type = 'button';
      btn.dataset.value  = ans.value || '';
      btn.dataset.skipQ3 = ans.skipQ3 ? 'true' : 'false';
      btn.innerHTML = `
        <span class="bc-quiz__answer-accent" aria-hidden="true"></span>
        <span class="bc-quiz__answer-badge" aria-hidden="true">${LETTERS[idx] !== undefined ? LETTERS[idx] : idx + 1}</span>
        <span class="bc-quiz__answer-label">${escHtml(ans.label)}</span>
        <svg class="bc-quiz__answer-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span class="bc-quiz__answer-check" aria-hidden="true"><svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 6l3 3 5-5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
      `;
      btn.addEventListener('click', () => onAnswerClick(questionId, ans, btn, answersEl));
      answersEl.appendChild(btn);
    });

    // Only toggle bc-active if not already on the question screen.
    // Re-adding bc-active each question re-fires bc-fadeIn and clobbers the slide animation.
    if (!SCREENS.question.classList.contains('bc-active')) {
      showScreen('question');
    }

    // Right panel visual image
    const visualImg       = document.getElementById('bc-q-visual-img');
    const mobileVisualImg = document.getElementById('bc-q-mobile-visual-img');
    if (visualImg) {
      visualImg.src = qData.visual_image || '';
      visualImg.style.objectPosition = qData.visual_image_position || 'center center';
    }
    if (mobileVisualImg) {
      mobileVisualImg.src = qData.visual_image || '';
      mobileVisualImg.style.objectPosition = qData.visual_image_position || 'center center';
    }

    // Quote overlay (show only when quote text is set)
    const quoteWrap   = document.getElementById('bc-q-quote-wrap');
    const quoteText   = document.getElementById('bc-q-quote');
    const quoteAuthor = document.getElementById('bc-q-quote-author');
    if (quoteText)   quoteText.textContent   = qData.visual_quote        || '';
    if (quoteAuthor) quoteAuthor.textContent = qData.visual_quote_author || '';
    if (quoteWrap) quoteWrap.style.display = qData.visual_quote ? 'block' : 'none';

    // Back button: hidden on Q1, visible on Q2+
    const backBtn = document.getElementById('bc-btn-back');
    if (backBtn) backBtn.style.display = stepNum > 1 ? 'flex' : 'none';

    // Enter animation
    var screenQEl = document.getElementById('bc-screen-question');
    if (screenQEl) {
      var innerEl = screenQEl.querySelector('.bc-quiz__modal-content');
      if (innerEl) {
        var inCls = state.direction < 0 ? 'bc-slide-in-l' : 'bc-slide-in-r';
        innerEl.classList.remove('bc-slide-in-r','bc-slide-in-l','bc-slide-out-l','bc-slide-out-r');
        innerEl.offsetWidth; // force reflow
        innerEl.classList.add(inCls);
        setTimeout(function() { innerEl.classList.remove(inCls); }, 220);
      }
    }
  }

  function onAnswerClick(questionId, ans, btn, answersEl) {
    bcq('answer', { question: questionId, value: (ans && ans.value) || '' });
    answersEl.querySelectorAll('.bc-quiz__answer').forEach(b => b.classList.remove('bc-selected'));
    btn.classList.add('bc-selected');

    // Slide exit (forward direction)
    state.direction = 1;
    var screenQ = document.getElementById('bc-screen-question');
    if (screenQ) {
      var inner = screenQ.querySelector('.bc-quiz__modal-content');
      if (inner) {
        inner.classList.remove('bc-slide-in-r','bc-slide-in-l','bc-slide-out-l','bc-slide-out-r');
        inner.classList.add('bc-slide-out-l');
      }
    }

    setTimeout(() => advance(questionId, ans), 350);
  }

  // ── Quiz flow ─────────────────────────────────────────────────────────────────
  function btn_skipQ3(ans) {
    return ans.skipQ3 === true;
  }

  // ── Back navigation ───────────────────────────────────────────────────────────
  function handleBack() {
    // Slide exit (backward direction)
    state.direction = -1;
    var screenQ = document.getElementById('bc-screen-question');
    if (screenQ) {
      var inner = screenQ.querySelector('.bc-quiz__modal-content');
      if (inner) {
        inner.classList.remove('bc-slide-in-r','bc-slide-in-l','bc-slide-out-l','bc-slide-out-r');
        inner.classList.add('bc-slide-out-r');
      }
    }
    setTimeout(function() {
      var cur = state.currentStep;
      if (cur === 1) {
        showScreen('welcome');
        state.currentStep = 0;
      } else if (cur === 2) {
        renderQuestion('q1_category', 1, 3);
        state.currentStep = 1;
      } else if (cur === 3) {
        var route = ROUTING[state.path.toLowerCase()];
        if (route) renderQuestion(route.q2, 2, 3);
        state.currentStep = 2;
      }
    }, 200);
  }

  function renderQ1() { bcqView(); bcq('start', { variant: s.klaviyo_event_name || '' }); state.currentStep = 1; renderQuestion('q1_category', 1, 3); }

  function copyVisualToPanel(targetId) {
    const qVis = document.getElementById('bc-q-visual-img');
    const tVis = document.getElementById(targetId);
    if (qVis && tVis && qVis.src && qVis.src !== window.location.href) {
      tVis.src = qVis.src;
      tVis.style.display = '';
    }
  }

  // Libellé d'une réponse à partir de sa valeur (pour reconstituer l'affichage).
  function answerLabelFor(questionId, value) {
    var q = getQuestion(questionId);
    if (!q) return '';
    for (var i = 0; i < (q.answers || []).length; i++) {
      if (q.answers[i].value === value) return q.answers[i].label;
    }
    return '';
  }

  // Reconstitue path / q2 / q3 depuis une clé de combinaison (ex.
  // WEIGHT_sugar_afternoon). Gère les valeurs à underscore (35_45, hot_flushes)
  // en s'appuyant sur les réponses connues du parcours. Utilisé par le lien de
  // rappel e-mail et par le hook de debug.
  function applyComboKey(key) {
    var rec = state.data && state.data.recs && state.data.recs[key];
    if (!key || !rec) return false;
    var parts = String(key).split('_');
    var path = parts[0];
    var route = ROUTING[path.toLowerCase()];
    if (!route) return false;
    var tail = parts.slice(1).join('_');
    var q2v = tail, q3v = null;
    var q2q = getQuestion(route.q2);
    if (q2q) {
      for (var i = 0; i < (q2q.answers || []).length; i++) {
        var v = q2q.answers[i].value;
        if (tail === v) { q2v = v; q3v = null; break; }
        if (tail.indexOf(v + '_') === 0) { q2v = v; q3v = tail.slice(v.length + 1); break; }
      }
    }
    state.path = path;
    state.q2Value = q2v;
    state.q3Value = q3v;
    state.q1Answer = answerLabelFor('q1_category', path);
    state.q2Answer = answerLabelFor(route.q2, q2v);
    state.q3Answer = q3v ? answerLabelFor(route.q3, q3v) : null;
    return true;
  }

  // ── Loading sequence ──────────────────────────────────────────────────────────
  function startLoading() {
    showScreen('loading');
    state.currentStep = 5;

    const fill      = document.getElementById('bc-loading-fill');
    const stepLabel = document.getElementById('bc-loading-step-label');
    const pctEl     = document.getElementById('bc-loading-pct');

    const stepTexts = [
      s.loading_step_1 || 'Analyse de vos réponses',
      s.loading_step_2 || 'Sélection des actifs',
      s.loading_step_3 || 'Création de votre protocole',
      s.loading_step_4 || 'Finalisation de votre routine',
    ];

    // Restart CSS progress bar animation
    if (fill) {
      fill.style.animation = 'none';
      fill.offsetHeight;
      fill.style.animation = '';
    }

    var TOTAL_MS  = 3600;
    var startTime = Date.now();
    var stepIdx   = 0;

    if (stepLabel) stepLabel.textContent = stepTexts[0];
    if (pctEl)     pctEl.textContent     = '0%';

    var stepInterval = setInterval(function () {
      stepIdx = (stepIdx + 1) % stepTexts.length;
      if (stepLabel) stepLabel.textContent = stepTexts[stepIdx];
    }, Math.floor(TOTAL_MS / stepTexts.length));

    var pctInterval = setInterval(function () {
      var elapsed = Date.now() - startTime;
      var raw     = Math.min(95, Math.round((elapsed / TOTAL_MS) * 100));
      if (pctEl) pctEl.textContent = raw + '%';
      if (elapsed >= TOTAL_MS) {
        clearInterval(pctInterval);
        clearInterval(stepInterval);
        if (pctEl) pctEl.textContent = '100%';
        setTimeout(function () {
          renderResults();
          showScreen('results');
          state.currentStep = 6;
        }, 300);
      }
    }, 80);
  }

  // ── Results ───────────────────────────────────────────────────────────────────
  function renderResults() {
    const profile = getProfile(state.path);
    if (!profile) {
      console.warn('[BCQuiz] No profile found for path:', state.path);
      return;
    }

    const pKey = PROFILE_MAP[state.path] || 'M';

    // 1. Hero
    setText('bc-r-title',    profile.label);
    setText('bc-r-subtitle', profile.result_title);

    const socialEl = document.getElementById('bc-r-social-count');
    if (socialEl) socialEl.textContent = String(profile.social_count || '');

    var badgeEl = document.getElementById('bc-r-badge-text');
    if (badgeEl) badgeEl.textContent = profile.badge || '';

    const revCountEl = document.getElementById('bc-r-review-count');
    if (revCountEl && profile.reviews_count) revCountEl.textContent = Number(profile.reviews_count).toLocaleString('fr-FR');

    // 2. Accordion (answers as pills)
    renderAccordionPills();

    // 3. Product showcase
    renderHeroProduct(profile.hero_product, pKey);
    renderAltProduct(profile.alt_products, pKey);
    renderPackProduct(profile.pack_product, pKey);
    initSelectionState();
    initCardInteractions();

    // 4. Ingredients
    renderIngredients(profile);

    // 5. Holistic tips (section 4)
    renderHolisticTips();

    // 6. Lifestyle split (section 4b)
    renderLifestyleSplit(profile);

    // 7. Diagnostic cards (section 5)
    renderDiagnosticCards(profile);

    // 7b. Étapes de la cure (section 5b)
    renderResultsTimeline(profile);

    // 8. Reviews (section 6)
    renderReviews(profile);

    // Reviews header: rating widget
    var ratingEl = document.getElementById('bc-r-reviews-rating');
    if (ratingEl && profile.reviews_rating) {
      ratingEl.innerHTML =
        '<span class="bc-quiz__r-reviews-rating-score">' + escHtml(profile.reviews_rating) + '</span>' +
        '<div class="bc-quiz__r-reviews-rating-stars">★★★★★</div>' +
        '<span class="bc-quiz__r-reviews-rating-count">' + Number(profile.reviews_count || 0).toLocaleString('fr-FR') + ' ' + escHtml(s.reviews_count_label || '') + '</span>';
    }
    // Reviews social text
    var socialTextEl = document.getElementById('bc-r-reviews-social-text');
    if (socialTextEl && profile.social_count) {
      socialTextEl.textContent = '+' + String(profile.social_count) + ' ' + (s.reviews_social_label || '');
    }

    // 9b. Remontée Klaviyo, une seule fois par passage
    if (!state._klaviyoSent) { state._klaviyoSent = true; trackQuizCompleted(); }

    // GA4 : conversion « quiz terminé » + profil rattaché au visiteur pour relier
    // un achat ultérieur (au checkout) à ce parcours
    if (!state._ga4CompleteSent) {
      state._ga4CompleteSent = true;
      var _gp = getProfile(state.path);
      ga4('quiz_complete', {
        parcours: state.path || '',
        combinaison: comboKey() || '',
        produit_principal: (_gp && _gp.hero_product && _gp.hero_product.title) || '',
        langue: quizLocale()
      });
      ga4SetProfile(state.path);
    }

    // 9. Sticky bar
    updateStickyBar();
    var stickyAtc = document.getElementById('bc-btn-sticky-atc');
    if (stickyAtc && !stickyAtc._bcListening) {
      stickyAtc._bcListening = true;
      stickyAtc.addEventListener('click', function() {
        if (stickyAtc.disabled) return;
        var items = [];
        try { items = JSON.parse(stickyAtc.dataset.cartItems || '[]'); } catch(e) {}
        if (!items.length && stickyAtc.dataset.variantId) items = [{ id: stickyAtc.dataset.variantId, qty: 1 }];
        if (!items.length) return;
        // évite un double envoi si l'acheteur reclique pendant la requête
        stickyAtc.disabled = true;
        addToCartMulti(items, true);
        setTimeout(function() { stickyAtc.disabled = false; }, 4000);
      });
    }
  }

  function renderHeroProduct(prod, pKey) {
    if (!prod) return;

    // ── Carousel ─────────────────────────────────────────────────────────────
    var slides = (prod.images && prod.images.length > 0) ? prod.images : (prod.image ? [prod.image] : []);
    var carouselIdx = 0;

    var imgEl    = document.getElementById('bc-r-hero-img');
    var prevBtn  = document.getElementById('bc-r-carousel-prev');
    var nextBtn  = document.getElementById('bc-r-carousel-next');
    var thumbsEl = document.getElementById('bc-r-carousel-thumbs');

    function updateCarousel() {
      if (imgEl && slides.length > 0) {
        imgEl.src = slides[carouselIdx];
        imgEl.alt = prod.title || '';
      }
      if (prevBtn) prevBtn.disabled = carouselIdx === 0;
      if (nextBtn) nextBtn.disabled = carouselIdx >= slides.length - 1;
      if (thumbsEl) {
        thumbsEl.querySelectorAll('.bc-quiz__r-carousel-thumb').forEach(function(el, i) {
          el.classList.toggle('bc-active', i === carouselIdx);
        });
      }
    }

    if (slides.length > 1) {
      if (prevBtn) prevBtn.style.display = '';
      if (nextBtn) nextBtn.style.display = '';
      if (thumbsEl) {
        thumbsEl.innerHTML = slides.map(function(src, i) {
          return '<img class="bc-quiz__r-carousel-thumb' + (i === 0 ? ' bc-active' : '') + '" src="' + escAttr(src) + '" alt="" loading="lazy" />';
        }).join('');
        thumbsEl.querySelectorAll('.bc-quiz__r-carousel-thumb').forEach(function(el, i) {
          el.addEventListener('click', function() { carouselIdx = i; updateCarousel(); });
        });
      }
    }
    if (prevBtn && !prevBtn._bcListening) {
      prevBtn._bcListening = true;
      prevBtn.addEventListener('click', function() { if (carouselIdx > 0) { carouselIdx--; updateCarousel(); } });
    }
    if (nextBtn && !nextBtn._bcListening) {
      nextBtn._bcListening = true;
      nextBtn.addEventListener('click', function() { if (carouselIdx < slides.length - 1) { carouselIdx++; updateCarousel(); } });
    }
    updateCarousel();
    // ─────────────────────────────────────────────────────────────────────────

    var heroSplit = splitProductName(prod.title);
    setText('bc-r-hero-name', heroSplit.name);
    var heroSubtitleEl = document.getElementById('bc-r-hero-subtitle');
    if (heroSubtitleEl) {
      heroSubtitleEl.textContent = heroSplit.subtitle || '';
      heroSubtitleEl.style.display = heroSplit.subtitle ? '' : 'none';
    }

    var benefitsRow = document.getElementById('bc-r-benefits-row');
    if (benefitsRow) {
      var bList = productText(prod.handle).benefits;
      benefitsRow.innerHTML = bList.map(function(text, i) {
        var icon = BENEFIT_ICONS[i] || BENEFIT_ICONS[0];
        return '<div class="bc-quiz__r-benefit-item">' +
          '<img class="bc-quiz__r-benefit-icon" src="' + escAttr(icon) + '" alt="" loading="lazy" />' +
          '<span>' + escHtml(text) + '</span>' +
          '</div>';
      }).join('');
    }

    // Note du haut : vraie note reviews.io du produit si dispo. Sinon on laisse
    // le repli déjà en place (4.6/5 en dur + results_verified_count via data-bind).
    var heroNote = productRating(prod);
    if (heroNote.real) {
      var heroScoreEl = document.getElementById('bc-r-hero-stars-score');
      var heroCountEl = document.getElementById('bc-r-hero-stars-count');
      if (heroScoreEl) heroScoreEl.textContent = heroNote.score_display;
      if (heroCountEl) heroCountEl.textContent = heroNote.count_display;
    }

    var thumb = document.getElementById('bc-r-selcard-hero-thumb');
    if (thumb) { thumb.src = prod.image || ''; thumb.alt = prod.title || ''; }
    setText('bc-r-selcard-hero-name', heroSplit.name);
    var selcardHeroSubtitleEl = document.getElementById('bc-r-selcard-hero-subtitle');
    if (selcardHeroSubtitleEl) {
      selcardHeroSubtitleEl.textContent = heroSplit.subtitle || '';
      selcardHeroSubtitleEl.style.display = heroSplit.subtitle ? '' : 'none';
    }
    setText('bc-r-selcard-hero-price', prod.price);
    setText('bc-r-selcard-hero-tag', heroTagline(prod));
    var heroSavingsEl = document.getElementById('bc-r-abo-hero-savings');
    if (heroSavingsEl && prod.price_raw) {
      heroSavingsEl.textContent = savingsTeaseText(prod.price_raw);
      heroSavingsEl.style.display = '';
    }
  }

  // Accepte un produit seul ou une liste : une combinaison peut pousser deux
  // alternatifs (c'est le cas de la plupart des profils Beauté).
  function renderAltProduct(prods, pKey) {
    var list_ = Array.isArray(prods) ? prods.filter(Boolean) : (prods ? [prods] : []);
    if (!list_.length) return;
    var container = document.getElementById('bc-r-alternatives');
    var list = document.getElementById('bc-r-alternatives-list');
    if (!container || !list) return;
    list.innerHTML = list_.map(function (prod, i) {
      return buildSelCard(prod, 'alt-' + i, productText(prod.handle).tagline, s.alt_badge_label || '');
    }).join('');
    container.style.display = '';
  }

  function renderPackProduct(prod, pKey) {
    if (!prod) return;
    var container = document.getElementById('bc-r-pack-section');
    var cardContainer = document.getElementById('bc-r-pack-card');
    if (!container || !cardContainer) return;
    var ctxLabel = document.getElementById('bc-r-pack-context-label');
    if (ctxLabel) ctxLabel.textContent = s.pack_context_label || '';
    cardContainer.innerHTML = buildSelCard(prod, 'pack', productText(prod.handle).tagline, s.pack_badge_label || '');
    container.style.display = '';
  }

  function buildSelCard(prod, cardId, tagline, badge) {
    var cid = escAttr(cardId);
    var badgeHtml = badge ? '<span class="bc-quiz__r-selcard-badge">' + escHtml(badge) + '</span>' : '';
    var savingsStr = prod.price_raw ? savingsTeaseText(prod.price_raw) : '';
    var savingsStyle = savingsStr ? '' : ' style="display:none"';
    var nameSplit = splitProductName(prod.title);
    var subtitleHtml = nameSplit.subtitle
      ? '<p class="bc-quiz__r-selcard-subtitle" id="bc-r-selcard-' + cid + '-subtitle">' + escHtml(nameSplit.subtitle) + '</p>'
      : '';
    return '<div class="bc-quiz__r-selcard" id="bc-selcard-' + cid + '" data-card-id="' + cid + '">' +
      '<div class="bc-quiz__r-selcard-checkbox" aria-hidden="true"><div class="bc-quiz__r-selcard-checkbox-inner"></div></div>' +
      '<div class="bc-quiz__r-selcard-thumb-wrap">' +
        '<img class="bc-quiz__r-selcard-thumb" src="' + escAttr(prod.image || '') + '" alt="' + escAttr(prod.title || '') + '" />' +
      '</div>' +
      '<div class="bc-quiz__r-selcard-body">' +
        '<div class="bc-quiz__r-selcard-info">' +
          badgeHtml +
          '<p class="bc-quiz__r-selcard-name" id="bc-r-selcard-' + cid + '-name">' + escHtml(nameSplit.name) + '</p>' +
          subtitleHtml +
          '<p class="bc-quiz__r-selcard-tag" id="bc-r-selcard-' + cid + '-tag">' + escHtml(tagline) + '</p>' +
        '</div>' +
        '<div class="bc-quiz__r-selcard-right">' +
          '<div class="bc-quiz__r-selcard-price-wrap">' +
            '<span class="bc-quiz__r-selcard-price-orig" id="bc-r-selcard-' + cid + '-orig"></span>' +
            '<p class="bc-quiz__r-selcard-price" id="bc-r-selcard-' + cid + '-price">' + escHtml(prod.price) + '</p>' +
          '</div>' +
          '<div class="bc-quiz__r-abotoggle" id="bc-abotoggle-' + cid + '" data-card-id="' + cid + '">' +
            '<div class="bc-quiz__r-abotoggle-switch" aria-hidden="true">' +
              '<div class="bc-quiz__r-abotoggle-track"></div>' +
              '<div class="bc-quiz__r-abotoggle-knob"></div>' +
            '</div>' +
            '<span class="bc-quiz__r-abotoggle-label">' + escHtml(s.results_abo_label || '') + '</span>' +
            '<button class="bc-quiz__r-abo-info-btn" aria-label="' + escAttr(s.abo_info_label || '') + '" type="button">i</button>' +
            '<span class="bc-quiz__r-abotoggle-savings" id="bc-r-abo-' + cid + '-savings"' + savingsStyle + '>' + escHtml(savingsStr) + '</span>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function initSelectionState() {
    _sel.selected = new Set(['hero']);
    _sel.aboMode = new Set();
    var heroCard = document.getElementById('bc-selcard-hero');
    if (heroCard) heroCard.classList.add('bc-selcard--selected');
  }

  function openAboPopup() {
    var popup = document.getElementById('bc-abo-popup');
    if (popup) { popup.classList.add('bc-abo-popup--open'); popup.setAttribute('aria-hidden', 'false'); }
  }
  function closeAboPopup() {
    var popup = document.getElementById('bc-abo-popup');
    if (popup) { popup.classList.remove('bc-abo-popup--open'); popup.setAttribute('aria-hidden', 'true'); }
  }

  function initCardInteractions() {
    var screen = document.getElementById('bc-screen-results');
    if (!screen || screen._bcInteractions) return;
    screen._bcInteractions = true;
    screen.addEventListener('click', function(e) {
      var infoBtn = e.target.closest('.bc-quiz__r-abo-info-btn');
      if (infoBtn) { e.stopPropagation(); openAboPopup(); return; }
      var toggle = e.target.closest('.bc-quiz__r-abotoggle');
      if (toggle) { e.stopPropagation(); handleAboToggle(toggle.dataset.cardId); return; }
      var card = e.target.closest('.bc-quiz__r-selcard');
      if (card) handleCardToggle(card.dataset.cardId, card);
    });
    document.addEventListener('click', function(e) {
      if (e.target.id === 'bc-abo-popup-close' || e.target.id === 'bc-abo-popup-backdrop') closeAboPopup();
    });
  }

  function handleCardToggle(cardId, card) {
    if (_sel.selected.has(cardId)) {
      _sel.selected.delete(cardId);
      card.classList.remove('bc-selcard--selected');
    } else {
      _sel.selected.add(cardId);
      card.classList.add('bc-selcard--selected');
    }
    updateStickyBar();
  }

  function handleAboToggle(cardId) {
    var toggle    = document.getElementById('bc-abotoggle-' + cardId);
    var priceEl   = document.getElementById('bc-r-selcard-' + cardId + '-price');
    var origEl    = document.getElementById('bc-r-selcard-' + cardId + '-orig');
    var savingsEl = document.getElementById('bc-r-abo-' + cardId + '-savings');
    var profile   = getProfile(state.path);
    if (!profile) return;
    var prod = productForCard(profile, cardId);
    if (!prod) return;

    if (_sel.aboMode.has(cardId)) {
      _sel.aboMode.delete(cardId);
      if (toggle)    toggle.classList.remove('bc-abo--active');
      if (priceEl)   priceEl.textContent = prod.price;
      if (origEl)    origEl.classList.remove('bc-visible');
      if (savingsEl) savingsEl.style.display = '';
    } else {
      _sel.aboMode.add(cardId);
      if (toggle)    toggle.classList.add('bc-abo--active');
      if (priceEl)   priceEl.textContent = aboPrice(prod.price_raw);
      if (origEl)    { origEl.textContent = prod.price; origEl.classList.add('bc-visible'); }
      if (savingsEl) savingsEl.style.display = 'none';
    }
    updateStickyBar();
  }

  function updateStickyBar() {
    var profile = getProfile(state.path);
    if (!profile) return;
    var total = 0, count = 0, thumbSrc = '';

    function addProd(prod, cardId) {
      if (!prod || !_sel.selected.has(cardId)) return;
      var raw = prod.price_raw || 0;
      total += _sel.aboMode.has(cardId) ? Math.round(raw * 0.9) : raw;
      count++;
      if (!thumbSrc) thumbSrc = prod.image || '';
    }
    var cardIds = ['hero'].concat((profile.alt_products || []).map(function (_, i) { return 'alt-' + i; })).concat(['pack']);
    cardIds.forEach(function (cardId) { addProd(productForCard(profile, cardId), cardId); });

    var thumbEl = document.getElementById('bc-r-sticky-thumb');
    if (thumbEl) thumbEl.src = thumbSrc;

    var countEl = document.getElementById('bc-r-sticky-count');
    // Le libellé est éditable : {n} est remplacé par le nombre de produits
    if (countEl) countEl.textContent = String(s.sticky_count_label || '').replace('{n}', count);

    var priceEl = document.getElementById('bc-r-sticky-price');
    if (priceEl) priceEl.textContent = (total / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';

    var items = [];
    cardIds.forEach(function (cardId) {
      var prod = productForCard(profile, cardId);
      if (_sel.selected.has(cardId) && prod && prod.variant_id) items.push({ id: prod.variant_id, qty: 1 });
    });
    var stickyAtcEl = document.getElementById('bc-btn-sticky-atc');
    if (stickyAtcEl) {
      stickyAtcEl.dataset.cartItems = JSON.stringify(items);
      if (items.length) stickyAtcEl.dataset.variantId = String(items[0].id);
    }
  }

  function renderAccordionPills() {
    var body = document.getElementById('bc-r-acc-body');
    if (!body) return;
    var answers = [];
    if (state.q1Answer) answers.push(state.q1Answer);
    if (state.q2Answer) answers.push(state.q2Answer);
    if (state.q3Answer) answers.push(state.q3Answer);
    body.innerHTML = answers.map(function(a, i) {
      return '<span class="bc-quiz__r-acc-pill">' +
        '<span class="bc-quiz__r-acc-pill-num">' + (i + 1) + '</span>' +
        '<span class="bc-quiz__r-acc-pill-text">' + escHtml(a) + '</span>' +
      '</span>';
    }).join('');
    var header  = document.getElementById('bc-r-acc-header');
    var chevron = document.getElementById('bc-r-acc-chevron');
    if (header) {
      header.addEventListener('click', function() {
        var isOpen = body.classList.toggle('bc-open');
        header.setAttribute('aria-expanded', String(isOpen));
        if (chevron) chevron.classList.toggle('bc-open', isOpen);
      });
      header.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); header.click(); }
      });
    }
  }

  function renderIngredients(profile) {
    var el = document.getElementById('bc-r-ingredients-list');
    if (!el) return;
    var items = (profile && profile.ingredients) || [];
    el.innerHTML = items.map(function(ing) {
      return '<p class="bc-quiz__r-ingredient-item">' +
        '<span class="bc-quiz__r-ingredient-name">' + escHtml(ing.name) + '</span>' +
        '<span class="bc-quiz__r-ingredient-benefit"> · ' + escHtml(ing.benefit) + '</span>' +
      '</p>';
    }).join('');
  }

  function renderDiagnosticCards(profile) {
    var el = document.getElementById('bc-r-diag-cards');
    if (!el) return;
    var labels = state.data.cardThemes || [];
    var cards = ((profile && profile.cards) || []).filter(function (t) { return t && t.trim(); });
    el.innerHTML = cards.map(function(text, i) {
      var theme  = { label: labels[i] || '', icon: CARD_ICONS[i] || '' };
      var numStr = String(i + 1).padStart(2, '0');
      return '<div class="bc-quiz__r-diag-card">' +
        '<span class="bc-quiz__r-diag-card-bg-num" aria-hidden="true">' + numStr + '</span>' +
        '<div class="bc-quiz__r-diag-card-top">' +
          (theme.icon ? '<img class="bc-quiz__r-diag-icon" src="' + escAttr(theme.icon) + '" alt="" loading="lazy"/>' : '') +
          '<div>' +
            '<span class="bc-quiz__r-diag-card-num">' + numStr + '</span>' +
            '<p class="bc-quiz__r-diag-card-label">' + escHtml(theme.label || '') + '</p>' +
          '</div>' +
        '</div>' +
        '<div class="bc-quiz__r-diag-card-sep"></div>' +
        '<p class="bc-quiz__r-diag-card-text">' + escHtml(text) + '</p>' +
      '</div>';
    }).join('');
    var dotsEl = document.getElementById('bc-r-cards-dots');
    if (dotsEl && cards.length > 1) {
      dotsEl.innerHTML = cards.map(function(_, i) {
        return '<span class="bc-quiz__r-cards-dot' + (i === 0 ? ' bc-active' : '') + '"></span>';
      }).join('');
      el.addEventListener('scroll', function() {
        var cardW = el.offsetWidth * 0.82 + 12;
        var idx = Math.min(cards.length - 1, Math.round(el.scrollLeft / cardW));
        dotsEl.querySelectorAll('.bc-quiz__r-cards-dot').forEach(function(d, i) {
          d.classList.toggle('bc-active', i === idx);
        });
      }, { passive: true });
    }
  }

  function renderResultsTimeline(profile) {
    var el = document.getElementById('bc-r-timeline-steps');
    if (!el) return;
    var steps = ((profile && profile.timeline) || []).filter(function (st) { return st.title || st.detail; });
    // Profil sans étapes renseignées : on masque la section plutôt que d'afficher un titre seul
    var section = document.getElementById('bc-r-timeline');
    if (section) section.style.display = steps.length ? '' : 'none';
    el.innerHTML = steps.map(function(step, i) {
      return '<div class="bc-quiz__r-timeline-step">' +
        '<div class="bc-quiz__r-tl-dot">' + (i + 1) + '</div>' +
        '<div>' +
          '<p class="bc-quiz__r-tl-week">'      + escHtml(step.label)  + '</p>' +
          '<p class="bc-quiz__r-tl-milestone">' + escHtml(step.title)  + '</p>' +
          '<p class="bc-quiz__r-tl-detail">'    + escHtml(step.detail) + '</p>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  function renderHolisticTips() {
    var el = document.getElementById('bc-r-holistic-tips');
    if (!el) return;
    // Textes éditables ; un conseil sans titre n'est pas affiché
    var TIP_ICONS = [
      CDN + 'natural_ingredients_1.png',
      CDN + 'vitality_and_inner_balance_59b0c759-b2dc-4897-9972-312c5dc032e4.png',
      CDN + 'light_rise.png',
      CDN + 'active_lifestyle_594444db-2295-457a-a579-cec724610f84.png'
    ];
    var tips = [1, 2, 3, 4].map(function (i) {
      return { icon: TIP_ICONS[i - 1], name: s['tip_' + i + '_name'] || '', detail: s['tip_' + i + '_detail'] || '' };
    }).filter(function (t) { return t.name; });
    el.innerHTML = tips.map(function(t, idx) {
      var iconStyle = t.icon === TIP_ICONS[0] ? ' style="filter:brightness(3.4) hue-rotate(-13deg) saturate(2)"' : '';
      return '<div class="bc-quiz__r-holistic-tip-card">' +
        '<div class="bc-quiz__r-holistic-tip-icon-wrap">' +
          '<img class="bc-quiz__r-holistic-tip-icon" src="' + escAttr(t.icon) + '" alt="" loading="lazy"' + iconStyle + '/>' +
        '</div>' +
        '<div class="bc-quiz__r-holistic-tip-text">' +
          '<p class="bc-quiz__r-holistic-tip-name">' + escHtml(t.name) + '</p>' +
          '<p class="bc-quiz__r-holistic-tip-detail">' + escHtml(t.detail) + '</p>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  function renderReviews(profile) {
    var el = document.getElementById('bc-r-reviews-carousel');
    if (!el) return;
    var reviews = (profile && profile.reviews) || [];
    el.innerHTML = reviews.map(function(r) {
      var rating = Number(r.rating) || 5;
      var starsStr = '★'.repeat(rating) + '☆'.repeat(5 - rating);
      var firstName = String(r.author || '').split('.')[0].split(' ')[0];
      // Pas de photo configurée : on garde l'initiale plutôt qu'une image cassée
      var avatar = r.photo
        ? '<img class="bc-quiz__r-review-avatar" src="' + escAttr(r.photo) + '" alt="" loading="lazy"/>'
        : '<span class="bc-quiz__r-review-avatar bc-quiz__r-review-avatar--initial">' + escHtml(firstName.charAt(0)) + '</span>';
      return '<div class="bc-quiz__r-review-card">' +
        '<div class="bc-quiz__r-review-top">' +
          '<div class="bc-quiz__r-review-author">' +
            avatar +
            '<span class="bc-quiz__r-review-name">' + escHtml(firstName) + '</span>' +
          '</div>' +
          '<div class="bc-quiz__r-review-meta">' +
            '<span class="bc-quiz__r-review-stars">' + escHtml(starsStr) + '</span>' +
            '<span class="bc-quiz__r-review-rating">' + rating + '.0 / 5</span>' +
          '</div>' +
        '</div>' +
        '<p class="bc-quiz__r-review-text">' + escHtml(r.text) + '</p>' +
        '<div class="bc-quiz__r-review-footer">' +
          '<span class="bc-quiz__r-review-badge">' + escHtml(s.reviews_verified_label || '') + '</span>' +
          '<span class="bc-quiz__r-review-city">' + escHtml(r.city) + '</span>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  function renderLifestyleSplit(profile) {
    var ls = (profile && profile.lifestyle) || {};
    var photo = document.getElementById('bc-r-lifestyle-photo');
    if (photo) {
      photo.src = ls.image || '';
      photo.alt = '';
      photo.style.display = ls.image ? '' : 'none';
    }
    setText('bc-r-lifestyle-title',      ls.title || (profile && profile.result_title) || '');
    setText('bc-r-lifestyle-para',       ls.text  || '');
    setText('bc-r-lifestyle-badge-text', (profile && profile.badge) || '');
  }

  function setupQuestionCursor() {
    var cursorEl  = document.getElementById('bc-q-cursor');
    var screen    = document.getElementById('bc-screen-question');
    var modalCard = screen ? screen.querySelector('.bc-quiz__modal-card') : null;
    if (!cursorEl || !screen) return;
    screen.addEventListener('mousemove', function(e) {
      cursorEl.style.transform = 'translate(' + (e.clientX - 22) + 'px,' + (e.clientY - 22) + 'px)';
      var onBackdrop = !modalCard || !modalCard.contains(e.target);
      cursorEl.classList.toggle('bc-cursor-visible', onBackdrop);
    });
    screen.addEventListener('mouseleave', function() {
      cursorEl.classList.remove('bc-cursor-visible');
    });
    screen.addEventListener('click', function(e) {
      if (modalCard && !modalCard.contains(e.target)) {
        closeQuiz();
      }
    });
  }

  function setupResultsCursor() {
    var cursorEl  = document.getElementById('bc-r-cursor');
    var backdrop  = document.getElementById('bc-r-backdrop');
    var modalCard = document.getElementById('bc-r-modal-card');
    var screen    = document.getElementById('bc-screen-results');
    if (!cursorEl || !screen) return;
    screen.addEventListener('mousemove', function(e) {
      cursorEl.style.transform = 'translate(' + (e.clientX - 22) + 'px,' + (e.clientY - 22) + 'px)';
    });
    if (backdrop) {
      backdrop.addEventListener('mouseenter', function() { cursorEl.classList.add('bc-cursor-visible'); });
      backdrop.addEventListener('mouseleave', function() { cursorEl.classList.remove('bc-cursor-visible'); });
      backdrop.addEventListener('click', closeQuiz);
    }
    if (modalCard) {
      modalCard.addEventListener('mouseenter', function() { cursorEl.classList.remove('bc-cursor-visible'); });
    }
  }

  // ── Add to cart ───────────────────────────────────────────────────────────────
  function addToCart(variantId, feedbackId) {
    if (!variantId) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
    })
      .then(res => res.json())
      .then(() => {
        const fb = document.getElementById(feedbackId);
        if (fb) {
          fb.classList.add('bc-show');
          setTimeout(() => fb.classList.remove('bc-show'), 3000);
        }
        // Optionally trigger cart drawer if theme supports it
        document.dispatchEvent(new CustomEvent('bc:cart:updated'));
      })
      .catch(err => console.error('[BCQuiz] Cart add failed', err));
  }

  // `goToCheckout` : le tiroir panier du thème est masqué pendant le quiz, donc
  // se contenter d'émettre l'événement laissait l'acheteur sans retour visible.
  function addToCartMulti(items, goToCheckout) {
    if (!items || !items.length) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items.map(function(i) { return { id: parseInt(i.id, 10), quantity: i.qty || 1 }; }) }),
    })
      .then(function(r) {
        if (!r.ok) return r.json().then(function(e) { throw new Error(e.description || r.status); });
        return r.json();
      })
      .then(function() {
        document.dispatchEvent(new CustomEvent('bc:cart:updated'));
        if (goToCheckout) window.location.href = s.checkout_url || '/checkout';
      })
      .catch(function(err) { console.error('[BCQuiz] Cart add failed', err); });
  }

  // ── Email collection ──────────────────────────────────────────────────────────
  // Validation « ça ressemble à une adresse e-mail » : du texte, un @, du texte,
  // un point, du texte. Sert à déverrouiller le bouton d'accès aux résultats.
  function isValidEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || '').trim());
  }

  function submitEmail(email, firstname) {
    if (!email) return;
    bcq('email', { profil: state.path || '' });
    var identify = { '$email': email };
    if (firstname) identify['$first_name'] = firstname;
    // le profil est rattaché au contact dès l'identification
    if (state.path) identify['QuizProfil'] = state.path;
    if (state.q2Value) identify['QuizQ2'] = state.q2Value;
    if (state.q3Value) identify['QuizQ3'] = state.q3Value;
    identify['QuizLangue'] = quizLocale();
    if (quizCountry()) identify['QuizPays'] = quizCountry();
    if (state.path) Object.assign(identify, quizProductProps());
    if (state.path) Object.assign(identify, quizHeroProps());
    if (state.path) Object.assign(identify, quizCardProps());
    if (comboKey()) identify['QuizResultUrl'] = quizResultUrl();
    klaviyoPush(['identify', identify]);
    // Abonnement marketing uniquement si la case d'opt-in est cochée (elle l'est
    // par défaut). Si la case est absente (thème pas encore à jour), on garde le
    // comportement actuel pour ne rien casser.
    var optinEl = document.getElementById('bc-email-optin');
    if (!optinEl || optinEl.checked) subscribeToList(email, firstname);
    ga4('quiz_email', { parcours: state.path || '', langue: quizLocale() });
    document.dispatchEvent(new CustomEvent('bc:quiz:email', { detail: { email: email, firstname: firstname } }));
  }

  // Abonne le contact à la liste Klaviyo de sa langue.
  // API « Client Subscriptions » : conçue pour le navigateur, clé PUBLIQUE
  // uniquement (company_id), jamais de clé privée. Klaviyo applique les réglages
  // d'opt-in de la liste (simple ou double opt-in).
  // Langue autoritative : celle du marché Shopify actif (localization), avec
  // repli sur <html lang>. Sert au routage de liste ET au tag QuizLangue, pour
  // qu'ils soient toujours cohérents.
  function quizLocale() {
    var l = (s.shop_language || document.documentElement.lang || '').slice(0, 2).toLowerCase();
    return l || 'nl';
  }
  function quizCountry() {
    return (s.shop_country || '').toUpperCase();
  }
  function listIdForLocale() {
    if (s.klaviyo_list_map) {
      var map = {};
      String(s.klaviyo_list_map).split(',').forEach(function (pair) {
        var kv = pair.split(':');
        if (kv.length === 2) map[kv[0].trim().toLowerCase()] = kv[1].trim();
      });
      if (map[quizLocale()]) return map[quizLocale()];
    }
    var byLang = { fr: s.klaviyo_list_fr, nl: s.klaviyo_list_nl, en: s.klaviyo_list_en };
    return byLang[quizLocale()] || '';
  }
  function subscribeToList(email, firstname) {
    if (s.klaviyo_enabled === false) return;
    var listId  = listIdForLocale();
    var company = s.klaviyo_company_id || 'UpP9Nq';
    if (!listId || !company || !window.fetch) return;

    var profileAttrs = { email: email };
    if (firstname) profileAttrs.first_name = firstname;
    profileAttrs.properties = {
      QuizProfil: state.path || '',        // = réponse Q1 (le parcours)
      QuizQ2: state.q2Value || '',
      QuizQ3: state.q3Value || '',
      QuizCombinaison: comboKey() || '',
      QuizLangue: quizLocale(),
      QuizPays: quizCountry()
    };
    Object.assign(profileAttrs.properties, quizProductProps());
    Object.assign(profileAttrs.properties, quizHeroProps());
    Object.assign(profileAttrs.properties, quizCardProps());
    profileAttrs.properties.QuizResultUrl = quizResultUrl();
    profileAttrs.subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } };

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: s.klaviyo_event_name || 'Quiz Insentials',
          profile: { data: { type: 'profile', attributes: profileAttrs } }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2026-07-15' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (window.location.search.indexOf('bc-debug') !== -1) {
        console.log('[BCQuiz] Klaviyo abonnement liste ' + listId + ' (' + quizLocale() + ') → HTTP ' + r.status);
      }
    }).catch(function (err) { console.warn('[BCQuiz] Abonnement Klaviyo échoué', err); });
  }


  // ── Klaviyo ───────────────────────────────────────────────────────────────────
  // Le SDK est chargé par la boutique : on pousse dans window.klaviyo (ou dans
  // _learnq pour les thèmes restés sur l'ancienne interface). Aucune clé ici.
  function klaviyoPush(args) {
    try {
      if (window.klaviyo && typeof window.klaviyo.push === 'function') { window.klaviyo.push(args); return true; }
      if (window._learnq && typeof window._learnq.push === 'function') { window._learnq.push(args); return true; }
    } catch (e) { console.warn('[BCQuiz] Klaviyo indisponible', e); }
    return false;
  }

  // ── GA4 ───────────────────────────────────────────────────────────────────────
  // Envoi d'un événement dans le GA4 de la boutique. gtag direct si disponible,
  // sinon dataLayer (au cas où un GTM serait ajouté plus tard).
  function ga4(name, params) {
    if (s.ga4_enabled === false) return false;
    try {
      if (typeof window.gtag === 'function') { window.gtag('event', name, params || {}); return true; }
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(Object.assign({ event: name }, params || {}));
        return true;
      }
    } catch (e) { /* silencieux : le tracking ne doit jamais casser le quiz */ }
    return false;
  }
  // Propriété utilisateur : elle « colle » au visiteur et permet à GA4 de relier
  // un achat ultérieur (fait au checkout Shopify) à son profil de quiz.
  function ga4SetProfile(profil) {
    if (s.ga4_enabled === false || !profil) return;
    try {
      if (typeof window.gtag === 'function') window.gtag('set', 'user_properties', { quiz_profil: profil });
    } catch (e) { /* silencieux */ }
  }

  // Liste ordonnée des produits recommandés : principal, alternatifs, pack
  function recommendedProducts(profile) {
    if (!profile) return [];
    var out = [];
    var push = function (prod, role) {
      if (!prod) return;
      // Textes rattachés au produit (accroche + 2 bénéfices), saisis une seule
      // fois dans « Textes des produits ». Le principal accepte une accroche sur
      // mesure par combinaison, exactement comme sur la page de résultat.
      var txt  = productText(prod.handle);
      var note = productRating(prod);
      out.push({
        role: role,
        position: out.length + 1,
        handle: prod.handle,
        title: prod.title,
        price: prod.price,
        price_cents: prod.price_raw,
        variant_id: prod.variant_id ? String(prod.variant_id) : '',
        url: prod.url,
        image: prod.image || '',
        // Enrichissement pour la carte produit de l'e-mail Klaviyo.
        // Accroche + 2 bénéfices : par produit. Note : vraie note reviews.io du
        // produit si dispo, sinon réassurance (repli). Champs *_display prêts à
        // coller tels quels dans le template Klaviyo.
        description: (role === 'hero' ? heroTagline(prod) : txt.tagline) || '',
        claim_1: (txt.benefits && txt.benefits[0]) || '',
        claim_2: (txt.benefits && txt.benefits[1]) || '',
        rating: note.value,
        reviews_count: note.count,
        rating_display: note.score_display,
        reviews_count_display: note.count_display,
        stars: '★★★★★',
      });
    };
    push(profile.hero_product, 'hero');
    (profile.alt_products || []).forEach(function (p, i) { push(p, 'alternative_' + (i + 1)); });
    push(profile.pack_product, 'pack');
    return out;
  }

  // Produits recommandés en propriétés de profil, pour segmenter directement
  // dessus (ex. « a reçu GLH-2 ») sans passer par l'événement.
  function quizProductProps() {
    var prods = recommendedProducts(getProfile(state.path));
    var hero = [], alt = [], pack = [];
    prods.forEach(function (p) {
      if (p.role === 'hero') hero.push(p.title);
      else if (p.role === 'pack') pack.push(p.title);
      else alt.push(p.title);
    });
    return {
      QuizProduitPrincipal: hero.join(' · '),
      QuizProduitsAlternatifs: alt.join(' · '),
      QuizProduitPack: pack.join(' · '),
      QuizProduits: prods.map(function (p) { return p.title; }).join(' · ')
    };
  }

  // Produit principal (hero) en propriétés de profil plates : utilisables dans
  // une campagne classique via {{ person.QuizProduitPrincipal... }}, sans flow.
  // (Les alternatifs et le pack, eux, restent dans event.Produits.)
  function quizHeroProps() {
    var prods = recommendedProducts(getProfile(state.path));
    var hero = null;
    for (var i = 0; i < prods.length; i++) {
      if (prods[i].role === 'hero') { hero = prods[i]; break; }
    }
    if (!hero) return {};
    return {
      QuizProduitPrincipalImage: hero.image || '',
      QuizProduitPrincipalUrl: hero.url || '',
      QuizProduitPrincipalPrix: hero.price || '',
      QuizProduitPrincipalNote: hero.rating_display || '',
      QuizProduitPrincipalAvis: hero.reviews_count_display || '',
      QuizProduitPrincipalClaim1: hero.claim_1 || '',
      QuizProduitPrincipalClaim2: hero.claim_2 || '',
      QuizProduitPrincipalDescription: hero.description || ''
    };
  }

  // Les 3 cartes « Ce que vos réponses révèlent » (diagnostic / cause / solution),
  // en propriétés de profil. Déjà traduites côté quiz : la valeur poussée est
  // dans la langue et le profil du visiteur, rien à gérer côté Klaviyo.
  function quizCardProps() {
    var prof = getProfile(state.path);
    var cards = (prof && prof.cards) || [];
    return {
      QuizDiagnostic: cards[0] || '',
      QuizCause: cards[1] || '',
      QuizSolution: cards[2] || ''
    };
  }

  // URL toute prête qui rouvre la page de résultat de ce contact. À coller
  // directement dans le bouton d'un e-mail Klaviyo via {{ person.QuizResultUrl }}.
  // Construite sur l'URL de la page complétée, donc la langue (/fr, /nl) est conservée.
  function quizResultUrl() {
    var key = comboKey();
    if (!key) return '';
    return window.location.origin + window.location.pathname + '?quiz_result=' + encodeURIComponent(key);
  }

  function trackQuizCompleted() {
    var profile  = getProfile(state.path);
    var products = recommendedProducts(profile);
    // Funnel tracker : 'complete' avec profil + produits (avant le gate Klaviyo,
    // pour que le tracker reçoive la complétion même si Klaviyo est coupé).
    bcq('complete', {
      profil: state.path || '',
      profil_nom: (profile && profile.label) || '',
      combinaison: comboKey() || '',
      produits: products.map(function (p) { return p.title; }),
      variant: s.klaviyo_event_name || ''
    });
    if (s.klaviyo_enabled === false) return;
    var payload = {
      // Parcours choisi
      Profil: state.path || '',
      ProfilNom: (profile && profile.label) || '',
      Combinaison: comboKey() || '',
      // Réponses : la valeur sert aux segments, le libellé sert à la lecture
      Q1Valeur: state.q1Value || '',
      Q1Reponse: state.q1Answer || '',
      Q2Valeur: state.q2Value || '',
      Q2Reponse: state.q2Answer || '',
      Q3Valeur: state.q3Value || '',
      Q3Reponse: state.q3Answer || '',
      // Produits recommandés, dans l'ordre d'affichage
      Produits: products,
      ProduitsNoms: products.map(function (p) { return p.title; }),
      ProduitPrincipal: products.length ? products[0].title : '',
      NombreProduits: products.length,
      // Repères
      Langue: (document.documentElement.lang || '').slice(0, 2),
      URL: window.location.href,
    };
    var name = s.klaviyo_event_name || 'Quiz Insentials Completed';
    var sent = klaviyoPush(['track', name, payload]);
    document.dispatchEvent(new CustomEvent('bc:quiz:completed', { detail: payload }));
    if (window.location.search.indexOf('bc-debug') !== -1) {
      console.log('[BCQuiz] Klaviyo ' + (sent ? 'envoyé' : 'NON envoyé') + ' :', name, payload);
    }
  }

  // ── Utility ───────────────────────────────────────────────────────────────────
  function setText(id, val) {
    const el = document.getElementById(id);
    if (el) el.textContent = val || '';
  }

  function escHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function escAttr(str) {
    return escHtml(str);
  }

  function aboPrice(priceRaw) {
    if (!priceRaw) return '';
    var v = Math.round(priceRaw * 0.9) / 100;
    return v.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function aboDiff(priceRaw) {
    if (!priceRaw) return '';
    var v = Math.round(priceRaw * 0.1) / 100;
    return v.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function savingsTeaseText(priceRaw) {
    if (!priceRaw) return '';
    var v = Math.round(priceRaw * 0.1) / 100;
    var amount = v.toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€';
    return String(s.abo_savings_label || '').replace('{amount}', amount);
  }

  // ── Helpers ───────────────────────────────────────────────────────────────────
  function closeQuiz() {
    Object.entries(SCREENS).forEach(([key, el]) => {
      if (el && key !== 'welcome') el.classList.remove('bc-active');
    });
    setOverlayOpen(false);
    state.currentStep = 0;
  }

  function updateEmailTeaser() {
    const profile    = getProfile(state.path);
    const teaserText = document.getElementById('bc-teaser-text');
    if (teaserText && profile) {
      teaserText.textContent = (profile.label || s.email_teaser_fallback || '') + (s.email_teaser_suffix || '');
    }
  }

  // ── Event wiring ──────────────────────────────────────────────────────────────
  function init() {
    bindSettings();
    bcqView();

    // Landing CTA
    const btnStart = document.getElementById('bc-btn-start');
    if (btnStart) {
      btnStart.addEventListener('click', () => {
        renderQ1();
      });
    }

    // Close buttons (modal X + results close)
    ['bc-btn-close', 'bc-btn-close-right', 'bc-btn-email-close', 'bc-btn-results-close'].forEach(function(id) {
      var btn = document.getElementById(id);
      if (btn) btn.addEventListener('click', closeQuiz);
    });

    // Email form submit
    const emailForm = document.getElementById('bc-email-form');
    if (emailForm) {
      const emailInput = document.getElementById('bc-email-input');
      const submitBtn  = emailForm.querySelector('.bc-quiz__email-submit');
      // Le bouton reste verrouillé tant que l'e-mail ne ressemble pas à un e-mail.
      function refreshEmailBtn() {
        if (!submitBtn) return;
        var ok = isValidEmail(emailInput ? emailInput.value : '');
        submitBtn.disabled = !ok;
        submitBtn.classList.toggle('bc-quiz__email-submit--locked', !ok);
      }
      if (emailInput) emailInput.addEventListener('input', refreshEmailBtn);
      refreshEmailBtn();
      emailForm.addEventListener('submit', e => {
        e.preventDefault();
        const fnInput   = document.getElementById('bc-firstname-input');
        const email     = emailInput ? emailInput.value.trim() : '';
        const firstname = fnInput ? fnInput.value.trim() : '';
        // Garde-fou : rien ne passe sans e-mail valide (le bouton « passer » reste dispo).
        if (!isValidEmail(email)) { if (emailInput) emailInput.focus(); return; }
        submitEmail(email, firstname);
        startLoading();
      });
    }

    // Email skip
    const btnEmailSkip = document.getElementById('bc-btn-email-skip');
    if (btnEmailSkip) {
      btnEmailSkip.addEventListener('click', () => {
        startLoading();
      });
    }

    // Back button
    const btnBack = document.getElementById('bc-btn-back');
    if (btnBack) {
      btnBack.addEventListener('click', handleBack);
    }

    // Restart button
    var btnRestart = document.getElementById('bc-btn-restart');
    if (btnRestart) {
      btnRestart.addEventListener('click', function() {
        closeQuiz();
        state.path = null;
        state.q1Answer = null;
        state.q2Answer = null;
        state.q3Answer = null;
        state._klaviyoSent = false;
        state._ga4Started = false;
        state._ga4CompleteSent = false;
        state.q1Value = null;
        state.q2Value = null;
        state.q3Value = null;
        state.skipQ3 = false;
        state.direction = 1;
        state.currentStep = 0;
      });
    }

    // Custom cursor on question + results backdrop
    setupQuestionCursor();
    setupResultsCursor();

    // Lien de rappel depuis un e-mail : ?quiz_result=WEIGHT_sugar_afternoon
    // rouvre directement la page de résultat, sans repasser le questionnaire.
    // On ne re-déclenche ni Klaviyo ni GA4 : la personne a déjà complété.
    try {
      var _params = new URLSearchParams(window.location.search);
      var _rk = _params.get('quiz_result');
      var _open = _params.get('quiz_open');
      if (_rk && applyComboKey(_rk)) {
        state._klaviyoSent = true;
        state._ga4CompleteSent = true;
        renderResults();
        showScreen('results');
      } else if (_open && _open !== '0' && _open !== 'false') {
        // Ouverture directe du quiz (liens d'ads) : on saute l'écran d'accueil
        // et on affiche la 1re question. Le suivi GA4 quiz_start part normalement.
        renderQ1();
      }
    } catch (e) { /* pas d'ouverture auto */ }
  }

  // Patch advance to track current step inline
  // Re-declare advance as a top-level scoped function that updates state:
  function advance(questionId, ans) {
    if (questionId === 'q1_category') {
      const pathKey = (ans.value || '').toLowerCase();
      const route   = ROUTING[pathKey];
      if (!route) {
        console.warn('[BCQuiz] Unknown path from Q1:', ans.value);
        return;
      }
      state.path     = route.path;
      state.q1Answer = ans.label || ans.value;
      state.q1Value  = ans.value;
      state.skipQ3   = false;
      state.questionSequence = ['q1_category', route.q2, route.q3];
      state.currentStep = 2;
      renderQuestion(route.q2, 2, 3);

    } else if (questionId.startsWith('q2_')) {
      state.q2Answer    = ans.label || ans.value;
      state.q2Value     = ans.value;
      state.q3Value     = null;
      state.skipQ3      = ans.skipQ3 === true;
      state.currentStep = 3;

      if (state.skipQ3) {
        updateEmailTeaser();
        copyVisualToPanel('bc-e-visual-img');
        showScreen('email');
        state.currentStep = 4;
      } else {
        const route = ROUTING[state.path.toLowerCase()];
        if (route) renderQuestion(route.q3, 3, 3);
      }

    } else if (questionId.startsWith('q3_')) {
      state.q3Answer    = ans.label || ans.value;
      state.q3Value     = ans.value;
      state.currentStep = 3;
      updateEmailTeaser();
      copyVisualToPanel('bc-e-visual-img');
      showScreen('email');
      state.currentStep = 4;
    }
  }

  // ── Kick off ──────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ── Debug hook (preview only) ─────────────────────────────────────────────────
  window.bcQuizDebug = {
    // bcQuizDebug.showProfile('BEAUTY', '45_55', 'wrinkles')
    showProfile: function (profileKey, q2, q3) {
      state.path    = profileKey;
      state.q2Value = q2 || null;
      state.q3Value = q3 || null;
      renderResults();
      showScreen('results');
    },
    // bcQuizDebug.showCombo('BEAUTY_45_55_wrinkles')
    showCombo: function (key) {
      if (!applyComboKey(key)) { console.warn('[BCQuiz] Combinaison inconnue:', key); return; }
      renderResults();
      showScreen('results');
    },
    listCombos: function () { return Object.keys((state.data && state.data.recs) || {}); },
    currentCombo: function () { return comboKey(); },
    getState: function () { return state; },
  };

})();
